import { Badge } from 'src/registry/ui/Badge';

type PricingPlanUsedInBadgeProps = {
    badgeTitle: string;
    innerBadgeTitle: string;
};

const PricingPlanUsedInBadge = ({ badgeTitle, innerBadgeTitle }: PricingPlanUsedInBadgeProps) => {
    return (
        <Badge theme="primary" className="shrink-0">
            {badgeTitle}
            <Badge theme="white" className="border-primary-200 text-primary-700 opacity-80">
                {innerBadgeTitle}
            </Badge>
        </Badge>
    );
};

export default PricingPlanUsedInBadge;
